import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsFillCircleFill } from '@react-icons/all-files/bs/BsFillCircleFill';
import { bind } from '../Utils/Bind';
import { Contract } from '../Utils/Contract';
import { toTimezoneAndFormat } from '../Utils/Date';
import { Enums } from '../Utils/Enums';
import { objectToHumanString } from '../Utils/String';
import { ContractModal } from './ContractModal';
import { ModalHandle } from './Modal';
import { Tooltip } from './Tooltip';

export interface IPartStateAlertProps {
    readonly partStatus: Mri.PartStatus.PartStatus;
    readonly className?: string;
}

@observer
export class PartStateAlert extends React.Component<IPartStateAlertProps> {
    public render() {
        const { className } = this.props;
        return (
            <Tooltip message={this.renderMessage()} className="part-state-alert">
                <BsFillCircleFill className={`warranty-dot ${className} text-${this.partStateClass}`} />
            </Tooltip>
        );
    }

    @computed
    private get partStateClass() {
        const { partStatus } = this.props;
        const partState = partStatus.partState;
        switch (partState) {
            default:
                return 'muted';
            case Mri.PartStatus.PartState.Discarded:
                return 'muted';
            case Mri.PartStatus.PartState.InstalledInAssembly:
                return 'success';
            case Mri.PartStatus.PartState.Inventory:
                return 'info-light';
            case Mri.PartStatus.PartState.Maintenance:
                return 'warning';
            case Mri.PartStatus.PartState.OutOfWarranty:
                return 'danger';
            case Mri.PartStatus.PartState.PickedToMO:
                return 'success';
            case Mri.PartStatus.PartState.RMA:
                return 'warning';
            case Mri.PartStatus.PartState.ShippedDisplay:
                return 'purple';
            case Mri.PartStatus.PartState.ToBeDeleted:
                return 'muted';
            case Mri.PartStatus.PartState.Uninstalled:
                return 'muted';
            case Mri.PartStatus.PartState.Unknown:
                return 'muted';
            case Mri.PartStatus.PartState.Unpowered:
                return 'muted';
            case Mri.PartStatus.PartState.Unsupported:
                return 'danger';
            case Mri.PartStatus.PartState.Vandalized:
                return 'orange';
        }
    }

    private renderMessage() {
        const { partStatus } = this.props;
        return (
            <div className="text-start">
                <span className={`badge rounded-pill bg-${this.partStateClass}`}>
                    {Enums.toString(Enums.PartState, partStatus.partState)}
                </span>
                <div>Start: {toTimezoneAndFormat(partStatus.startDate, 'MMMM d, yyyy', 'UTC')}</div>
                <div>Comments: {partStatus.comments || '-'}</div>
                <div>
                    Payload:
                    <pre>
                        <code>{objectToHumanString(partStatus.payload, true) || '-'}</code>
                    </pre>
                </div>
            </div>
        );
    }
}
